import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  clearSubAccountFromLocalStorage,
  getSubAccountFromLocalStorage,
} from 'features/subAccounts/utils';
import { RenderIfParticipant } from 'features/user/components/RenderIfParticipant';

import { HeaderMenuContent } from './MenuContent';
import { SubAccountsMenu } from './SubAccountsMenu';

type HeaderMenuPropTypes = {
  name: string;
  url: string;
  email: string;
};

const HeaderMenu = ({ name, email, url }: HeaderMenuPropTypes) => {
  const { logout } = useAuth0();

  const isLoggedInWithSubAccount = !!getSubAccountFromLocalStorage();

  const navigate = useNavigate();

  const navigateToSettingsPage = useCallback(() => {
    navigate('coach/settings');
  }, [navigate]);

  const handleLogout = useCallback(() => {
    clearSubAccountFromLocalStorage();
    logout({ returnTo: window.location.origin });
  }, [logout]);

  return (
    <HeaderMenuContent
      navigateToSettingsPage={navigateToSettingsPage}
      handleLogout={handleLogout}
      name={name}
      email={isLoggedInWithSubAccount ? null : email}
      profileUrl={url}
    >
      <RenderIfParticipant>
        <SubAccountsMenu />
      </RenderIfParticipant>
    </HeaderMenuContent>
  );
};

export default HeaderMenu;
